import { render, staticRenderFns } from "./ReturnsList.vue?vue&type=template&id=12f39671&scoped=true"
import script from "./ReturnsList.vue?vue&type=script&lang=js"
export * from "./ReturnsList.vue?vue&type=script&lang=js"
import style0 from "./ReturnsList.vue?vue&type=style&index=0&id=12f39671&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f39671",
  null
  
)

export default component.exports